import { createSelector } from 'reselect';

import { rcsSupplierInfo } from '../RcsSupplierInfoSelectors';


function crn (state, ownProps) {
  return ownProps.crn;
}

function databaseId (state, ownProps) {
  return ownProps.databaseId;
}

export function rcsSupplierInfoByIdFactory () {

  const rcsSupplierInfoById = createSelector(
    [rcsSupplierInfo, databaseId, crn],
    (rcsSupplierInfo, databaseId, crn) => {

      return rcsSupplierInfo.getIn([databaseId, crn]);
    },
  );

  return rcsSupplierInfoById;
}

